// Downscales large uploads in the browser so logos and banners load fast and fit their slots.
const SKIP = ['image/svg+xml', 'image/gif'];

const loadImage = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Could not read the image')); };
  img.src = url;
});

const toBlob = (canvas, type, quality) => new Promise((resolve) => canvas.toBlob(resolve, type, quality));

/** Returns the file unchanged when it is small enough (or not a raster image), else a resized WebP/JPEG. */
export async function resizeImage(file, { maxWidth = 1600, maxHeight = 1600, quality = 0.85 } = {}) {
  if (!file || !file.type?.startsWith('image/') || SKIP.includes(file.type)) return file;
  const img = await loadImage(file);
  const scale = Math.min(1, maxWidth / img.naturalWidth, maxHeight / img.naturalHeight);
  if (scale === 1 && file.size < 400 * 1024) return file;
  const width = Math.max(1, Math.round(img.naturalWidth * scale));
  const height = Math.max(1, Math.round(img.naturalHeight * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(img, 0, 0, width, height);
  // WebP keeps transparency (logos) and is much smaller; fall back to JPEG/PNG where unsupported.
  let blob = await toBlob(canvas, 'image/webp', quality);
  let type = 'image/webp';
  if (!blob || blob.type !== 'image/webp') {
    type = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
    blob = await toBlob(canvas, type, quality);
  }
  if (!blob || blob.size >= file.size) return file;
  const name = file.name.replace(/\.[^.]+$/, '') + (type === 'image/webp' ? '.webp' : type === 'image/png' ? '.png' : '.jpg');
  return new File([blob], name, { type });
}

export const IMAGE_LIMITS = {
  portal_logo: { maxWidth: 600, maxHeight: 600 },
  portal_banner: { maxWidth: 2000, maxHeight: 1400 },
  scan_logo: { maxWidth: 800, maxHeight: 800 },
  form_logo: { maxWidth: 1600, maxHeight: 600 },
  page_background: { maxWidth: 2400, maxHeight: 2400 },
  form_background: { maxWidth: 2400, maxHeight: 2400 },
  ticketing_banner: { maxWidth: 2400, maxHeight: 1200 },
  ticketing_icon: { maxWidth: 256, maxHeight: 256 },
  ticketing_art: { maxWidth: 800, maxHeight: 400 },
};
